export default __webpack_public_path__ + "static/media/americanRoulette.3b7246ef.svg";